<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { checkboxGroupProps } from './checkbox-group'

defineOptions({
  name: 'VsCheckboxGroup',
})

const props = defineProps(checkboxGroupProps)

// init here
</script>
